/**
 * Compact relative-time formatter for activity-style rows.
 * "just now" · "5m ago" · "3h ago" · "2d ago" · "4mo ago" · "1y ago"
 *
 * Switches from minutes to hours at 60 minutes, hours to days at 48 hours
 * (so "47h" reads more naturally than "1d 23h"), days to months at 30 days,
 * months to years at 12 months.
 */
export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const ms = Date.now() - then;
  if (ms < 60_000) return "just now";
  const min = Math.floor(ms / 60_000);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 48) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  const mo = Math.floor(day / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(mo / 12)}y ago`;
}
